<template>
  <section
    class="component-ccc69593"
    resmed-component-name="card_carousel_50/50_icon-line_graphic_text_cta"
  >
    <div class="component">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="headings text-center">
              <eyebrow-icon
                v-if="acf.eyebrowicon"
                v-bind:eyebrowicon="acf.eyebrowicon"
                style="margin: 0 auto"
              ></eyebrow-icon>
              <h5>{{ acf.title }}</h5>
              <h2>{{ acf.headline }}</h2>
              <p class="mb-4" v-html="acf.description"></p>
            </div>
          </div>
        </div>
      </div>

      <div class="swiper container px-xs-sm-2">
        <div class="row">
          <div class="col" style="padding: 0">
            <div class="seek">
              <div class="seek-wrapper" v-show="sliderControlsVisible">
                <a
                  rel="swiperButtonPrev"
                  href="#"
                  class="btn navigation-icon left-caret swiper-button-prev"
                ></a>
                <a
                  rel="swiperButtonNext"
                  href="#"
                  class="btn navigation-icon right-caret swiper-button-next"
                ></a>
              </div>

              <div
                ref="swiperContainer"
                class="swiper-container"
                v-bind:class="`-mode-${[$root.mode]}`"
              >
                <div class="items swiper-wrapper">
                  <div
                    class="item swiper-slide mb-3 mb-md-0"
                    v-for="(item, index) in acf.products"
                    v-bind:class="{ overflow: overflow && index >= 3 }"
                  >
                    <div class="embed-responsive embed-responsive-1by1">
                      <div class="wrapper embed-responsive-item">
                        <figure>
                          <figcaption
                            v-bind:class="{
                              'text-color-reverse':
                                item['reverse-color'] === 'black',
                            }"
                          >
                            <h3 v-html="item.title"></h3>
                            <p>{{ item.description }}</p>

                            <a
                              v-bind:href="item.href"
                              class="ctaButton cta-plain text-red icon right-arrow"
                              >{{ item.cta }}</a
                            >
                          </figcaption>
                        </figure>
                      </div>
                    </div>
                  </div>

                  <a
                    href="#"
                    v-on:click.prevent="overflow = !overflow"
                    v-if="overflow"
                    class="
                      d-inline-block d-md-none
                      btn
                      cta-pill
                      hallow-red
                      icon
                      move-expand
                    "
                    style="margin: 3rem auto 0 auto"
                    >Load more</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-show="sliderControlsVisible">
          <div class="col">
            <div ref="swiperPagination" class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import helper from "../../mixins/swiper-helper";

export default {
  name: "component-ccc69593", // card_carousel_50/50_icon-line_graphic_text_cta
  props: ["acf"],
  data() {
    return {
      initialized: false,
      slider: undefined,
      overflow: true,
    };
  },
  mixins: [helper],
  computed: {
    sliderControlsVisible() {
      return this.shouldUseSlider && this.acf.products.length > 2;
    },
    shouldUseSlider() {
      return !["xs", "sm"].includes(this.$root.mode);
    },
  },
  watch: {
    shouldUseSlider(v) {
      if (this.initialized) {
        if (v) {
          this.swhReload();
        } else {
          this.overflow = this.acf.products.length > 2;
          this.swhDestroy();
        }
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.shouldUseSlider) {
        this.swhReload();
      }

      this.initialized = true;
    });
  },
  methods: {
    swhCreate() {
      this.slider = new swiper(this.$refs.swiperContainer, {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 0,
        freeMode: false,
        freeModeSticky: true,
        // loop: true,
        pagination: {
          el: this.$refs.swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: this.$refs.swiperButtonNext,
          prevEl: this.$refs.swiperButtonPrev,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-ccc69593 {
  background-image: linear-gradient(to bottom, #eaf1f8, #c4c9de);
  padding: 5rem 0 4rem 0;
}

h2 {
  margin-bottom: 1.5rem;
}

h3 {
  margin-bottom: 0.325rem;
}

h5 {
  position: relative;
  margin-bottom: 0.75rem;

  @extend %eyebrow-center;
}

@media (max-width: 767px) {
  .overflow {
    display: none;
  }
}

@media (max-width: 991px) {
  .swiper {
    max-width: none;
    width: 90vw !important;
  }
}

.text-color-reverse {
  h3,
  p {
    color: $cc-resmed-black;
  }
}

.seek-wrapper {
  position: absolute;
  z-index: 1;

  width: 30%;
  bottom: -42px;
  left: 50%;
  transform: translateX(-50%);

  @media (min-width: 992px) {
    width: 20%;
  }

  @media (min-width: 1306px) {
    width: 100%;
    bottom: auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  a:nth-child(1) {
    float: left;
    transform: translateX(-4rem) scale(1.4);
  }

  a:nth-child(2) {
    float: right;
    transform: translateX(4rem) scale(1.4);
  }
}

.-mode-md,
.-mode-lg,
.-mode-xl {
  &.swiper-container {
    position: relative;
    width: 100%;
    height: 100%;

    overflow: hidden;
    padding: 1rem 0 2rem 0;
    margin: 0 auto;
    z-index: 1;
  }

  .items {
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .item {
    display: flex;
    flex-shrink: 0;
    align-items: center;

    padding: 0 0.725rem;
    width: calc(100% / 2);
  }
}

.item {
  padding: 0 0.625rem;

  > div {
    box-shadow: -3px 0.875rem 12px 0 rgba(0, 0, 0, 0.125);
    // box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.125)
  }

  %zoom {
    &:hover {
      ~ img {
        transform: scale(1.25);
      }
    }
  }

  .embed-responsive-item {
    border-radius: 6px;
    overflow: hidden;
  }

  .wrapper {
    background-image: url(#{$assets}/images/nasal-nasal-pillows-masks-cushion@2x.jpg);
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
  }

  figure {
    > div:first-child {
      width: 100%;
      position: absolute;
      z-index: 2;

      @extend %zoom;
    }

    img {
      position: absolute;
      transform: scale(1.0625);
      transition: transform 0.5s ease-out;
    }

    figcaption {
      position: absolute;
      bottom: 0;
      z-index: 3;

      margin: 0 auto;
      padding: 2rem;
      width: 100%;

      left: 50%;
      transform: translateX(-50%);

      background-color: $cc-resmed-white;

      @extend %zoom;
    }
  }
}
</style>